import { FilterSelect } from "components/form-elements/FilterSelect";
import { useField, useForm } from "lib/form";
import React, { useState, useEffect, FC } from "react";
import { useFilter } from "services/filter";
import { useCount } from "services/search";
import { getModelOptions } from "./getModelOptions";

type Props = {
    autoHeight?: boolean;
    isHomepage?: boolean;
    forceDisabledPlaceholder?: boolean;
};

export const ModelFilter: FC<Props> = ({ autoHeight, isHomepage, forceDisabledPlaceholder }) => {
    const [value] = useField<string[]>("merkIds");
    const [brandIds, setBrandIds] = useState(value || []);
    const counts = useCount("modellen");
    const models = useFilter("modellen", brandIds);
    const brands = useFilter("merken");

    useEffect(() => {
        if (value) {
            setBrandIds(value);
        }
    }, [value]);

    useForm({
        onChange: (values: any) => {
            setBrandIds(values.merkIds);
        }
    });

    return (
        <FilterSelect
            fieldName="modelIds"
            label={
                getModelOptions(brandIds, brands, counts, models).length === 0
                    ? "Kies eerst een merk"
                    : "Model"
            }
            autoHeight={autoHeight}
            isMulti
            options={getModelOptions(brandIds, brands, counts, models)}
            noMakeSelected="Je hebt nog geen merk(en) geselecteerd. Selecteer eerst een merk om vervolgens op modellen te filteren."
            notAvailableMessage="Model is niet beschikbaar."
            ariaLabel="Model"
            disabled={getModelOptions(brandIds, brands, counts, models).length === 0}
            isHomepage={isHomepage}
            forceDisabledPlaceholder={forceDisabledPlaceholder}
        />
    );
};
